<template>
    <a href="https://codenotary.io" class="powered-by" target="_blank" v-if="!hideBranding">
        <i-tooltip :disabled="!isBlankLayout">
            <img src="@/assets/ci-logo.svg" />
            <template slot="body">
                {{ $t('codenotary') }}
            </template>
        </i-tooltip>
        <span v-show="!isBlankLayout">{{ $t('codenotary') }}</span>
    </a>
</template>

<style lang="scss" scoped>
@import '~@inkline/inkline/src/css/config';
@import '~@inkline/inkline/src/css/mixins';

.powered-by {
    display: flex;
    justify-content: center;
    align-items: center;
    color: $text-muted;
    font-size: font-size('sm');
    padding-left: $spacer;
    padding-right: $spacer;
    margin-top: $spacer;
    text-align: center;

    img {
        max-width: 20px;
        margin-right: $spacer / 2;
    }
}
</style>

<script>
import StatusComponentMixin from "../mixins/StatusComponentMixin";

export default {
    mixins: [
        StatusComponentMixin
    ],
    computed: {
        hideBranding() {
            return this.$route.query.hideBranding;
        }
    }
};
</script>
